import { render, staticRenderFns } from "./work-permit-history.component.vue?vue&type=template&id=bb8bb6da"
import script from "./work-permit-history.component.ts?vue&type=script&lang=ts&external"
export * from "./work-permit-history.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb8bb6da')) {
      api.createRecord('bb8bb6da', component.options)
    } else {
      api.reload('bb8bb6da', component.options)
    }
    module.hot.accept("./work-permit-history.component.vue?vue&type=template&id=bb8bb6da", function () {
      api.rerender('bb8bb6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/work-permit-history/work-permit-history.component.vue"
export default component.exports